import * as THREE from 'three'

const _instance = new THREE.LoadingManager()

const LoadingManager = _instance
export default LoadingManager
